import type {
  SensitivityAnalysisResult,
  SensitivityFeatureKey,
  SensitivityRoundResult,
} from '@aloft/toolkit-shared';

import { createContext, useContext } from 'react';

type PropertyGridSensitivityContextValue = {
  sensitivityResult?: SensitivityAnalysisResult;
  sensitivityFeatureKey?: SensitivityFeatureKey;
  selectedRound?: SensitivityRoundResult;
};

export const PropertyGridSensitivityContext = createContext<PropertyGridSensitivityContextValue>(
  {},
);

export const useSensitivityContext = () => useContext(PropertyGridSensitivityContext);
